
const digest = '6ca27b963759267dd1e781be9563678ac49f602cdd43c8213b1ea4d6ba9c9454';
const classes = {"formWrapper":"_formWrapper_a72da_1"};
const css = `._formWrapper_a72da_1 {
  padding: 24px;
  border: 1px solid #eaedf3;
  border-top: 0;
  background: #ffffff;
  overflow-y: scroll;
  box-shadow: inset 0 4px 0 0 rgba(226, 229, 237, 0.3);
  -ms-overflow-style: auto;
  scrollbar-width: 3px;
}
._formWrapper_a72da_1::-webkit-scrollbar {
  display: block;
}
._formWrapper_a72da_1::-webkit-scrollbar {
  width: 4px;
  height: 4px;
  padding: 2px;
}
._formWrapper_a72da_1::-webkit-scrollbar-track {
  background: #f1f1f1;
}
._formWrapper_a72da_1::-webkit-scrollbar-thumb {
  background: #3e3f42;
  border-radius: 4px;
}
._formWrapper_a72da_1::-webkit-scrollbar-thumb:hover {
  background: #3e3f42;
  border-radius: 4px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  